import { Component, Input, OnInit } from '@angular/core';
import { WizardStep } from 'src/app/models/wizard/wizard-step';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  @Input() step: WizardStep = new WizardStep();
  @Input() stepNumber: number = 0;
  step1Text: string = "";
  step2Text: string = "";
  step3Text: string = "";
  step4Text: string = "";
  showFlexLink: boolean = false;
  flexLinkUrl: string = "";

  constructor(
    private confSvc: ConfigService,
  ) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.showFlexLink = this.confSvc.getBool("showFlexLink");
    this.flexLinkUrl = this.confSvc.getString("flexLinkUrl");

    this.step1Text = this.confSvc.getString("progressBarStep1Text");
    this.step2Text = this.confSvc.getString("progressBarStep2Text");
    this.step3Text = this.confSvc.getString("progressBarStep3Text");
    this.step4Text = this.confSvc.getString("progressBarStep4Text");
  }

getText(): string {
    switch (this.stepNumber) {
      case 1:
        return this.step1Text;
      case 2:
        return this.step2Text;
      case 3:
        return this.step3Text;
      case 4:
        return this.step4Text;
      default:
        return "";
    }
  }
  
}
